import { DialogTitle, DialogContent } from '@mui/material';
import WrestlerNameForm from './WrestlerNameForm';

export default function WrestlerNameStep() {
    return (
        <>
            <DialogTitle>Wrestler Name</DialogTitle>
            <DialogContent>
                <WrestlerNameForm />
            </DialogContent>
        </>
    );
}
